import { environment } from "src/environments/environment";

export const purpleTheme = (): string[] => {
  let latinLocale = [];

  if (environment.features.hungarian) {
    latinLocale = [...latinLocale, "hu-hu"];
  }

  return latinLocale;
};
